// utils/post/comments/countCommentReplies.ts

export interface CommentReplyNode {
    databaseId: number;
    // Add other relevant fields if necessary
    replies?: {
        nodes: CommentReplyNode[];
    };
}

/**
 * Counts the total number of comment replies recursively.
 * @param replies - An array of comment replies.
 * @returns The total count of replies.
 */
export function countCommentReplies(replies: CommentReplyNode[]): number {
    let count = replies.length;
    replies.forEach((reply) => {
        if (reply.replies && reply.replies.nodes.length > 0) {
            count += countCommentReplies(reply.replies.nodes);
        }
    });
    return count;
}
